<template>
    <div>
        <div class="p-fluid">

            <div class="formgrid grid">
                <div class="field col-12 md:col-6 lg:col-3">
                    <label>Region</label>
                    <Dropdown id="region_id" dataKey="region_id" v-model="filters.region_id"
                        :loading="loadingDropdownRegion" :options="dataDropdownRegion" optionLabel="label"
                        optionValue="region_id" placeholder="Pilih Region" @change="changeAsm()" :filter="true"
                        :showClear="true" @filter="searchDropdownRegion($event, 'filter')" />
                </div>
                <div class="field col-12 md:col-6 lg:col-3">
                    <label>ASM</label>
                    <Dropdown id="user_code" dataKey="user_code" v-model="filters.user_code"
                        :loading="loadingDropdownAsm" :options="dataDropdownAsm" optionLabel="label"
                        optionValue="user_code" placeholder="Pilih ASM" :filter="true" :showClear="true"
                        @filter="searchDropdownAsm($event, 'filter')" />
                </div>
            </div>
            <div class="formgrid grid">
                <div class="field col-12 md:col-6 lg:col-3">
                    <label>KPI Type</label>
                    <Dropdown id="kpi_type" dataKey="kpi_type"  @change="onKpiChange" v-model="filters.kpi_type" :options="dataDropdownKpiType"
                        optionLabel="label" optionValue="value" placeholder="Pilih Type" :filter="true"
                        :showClear="true" />
                </div>
                <div class="field col-12 md:col-6 lg:col-3">
                    <label for="period">Periode</label>
                    <Dropdown v-model="filters.periode_label"  optionLabel="label" :filter="true" optionValue="value" :options="periodeOptions" placeholder="Pilih Periode" />
                </div>

            </div>
        </div>
        <Button :loading="loading" label="Filter" icon="pi pi-search" class="p-button-warning mr-2 my-1"
            @click="getDataTable" />
    </div>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            // loading
            loading: false,
            loadingDropdownRegion: false,
            loadingDropdownAsm: false,

            // dataDropdown
            dataDropdownRegion: null,
            dataDropdownAsm: null,
            dataDropdownKpiType: [
                { label: 'Coaching Completion', value: 'Coaching Completion' },
                { label: 'Coaching Coverage', value: 'Coaching Coverage' },
                { label: 'Training', value: 'Training' }
            ],
            periodeOptions: [],

            // filter
            filters: {
                region_id: null,
                user_code: null,
                kpi_type: null,
                periode_label: null
            },
            period: [new Date(), new Date()],
            maxDate: null,
            minDate: null,
        };
    },
    created() {
        this.searchDropdownRegion("");
    },
    watch: {
        period() {
            //max range 30 days
            this.maxDate = new Date(
                this.period[0].getFullYear(),
                this.period[0].getMonth(),
                this.period[0].getDate() + 30
            );
        },
        filterValue(val) {
            this.searchCountries(val)
        }
    },
    computed: {
        period_start_label() {
            return moment(this.period[0], "YYYY-MM-DD").format("YYYY-MM-DD");
        },
        period_end_label() {
            return moment(this.period[1], "YYYY-MM-DD").format("YYYY-MM-DD");
        },
    },
    methods: {
        // DROPDOWN
        searchDropdownRegion(event, purpose, valueEdit) {
            setTimeout(() => {
                if (valueEdit) {
                    this.$refs.dreg.filterValue = valueEdit;
                }

                if (purpose == "filter") {
                    this.loadingDropdownRegion = true;
                }

                this.axios({
                    method: "GET",
                    url: process.env.VUE_APP_ROOT_API + "web/select2/region-kpi",
                    params: {
                        search: valueEdit ? valueEdit : event.value
                    },
                })
                    .then((res) => {
                        if (purpose == "filter") {
                            this.dataDropdownRegion = res.data.data;
                            this.loadingDropdownRegion = false;
                        } else if (purpose == null) {
                            this.dataDropdownRegion = res.data.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }, 250);
        },
        changeAsm() {
            this.filters.user_code = null;
            this.dataDropdownAsm = null;
            this.searchDropdownAsm("");
        },
        searchDropdownAsm(event, purpose, valueEdit) {
            setTimeout(() => {
                if (this.filters.region_id) {
                    if (valueEdit) {
                        this.$refs.dsubbranch.filterValue = valueEdit;
                    }

                    if (purpose == "filter") {
                        this.loadingDropdownAsm = true;
                    }

                    this.axios({
                        method: "GET",
                        url: process.env.VUE_APP_ROOT_API + "web/select2/asm-kpi",
                        params: {
                            search: valueEdit ? valueEdit : event.value,
                            region_id: this.filters.region_id,
                        },
                    })
                        .then((res) => {
                            if (purpose == "filter") {
                                this.dataDropdownAsm = res.data.data;
                                this.loadingDropdownAsm = false;
                            } else if (purpose == null) {
                                this.dataDropdownAsm = res.data.data;
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            }, 250);
        },
        getDataTable() {
            if (
                this.period_start_label !== null &&
                this.period_end_label !== null &&
                this.period_start_label !== "Invalid date" &&
                this.period_end_label !== "Invalid date"
            ) {
                this.$emit("submit");
            } else {
                alert("Pastikan rentang waktu sudah benar atau tidak kosong");
            }
        },
        onKpiChange() {
            const monthNames = [
                'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
                'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
            ];

            if (this.filters.kpi_type === 'Training') {
                // Tahun mulai dari 2025 sampai 2030
                this.periodeOptions = Array.from({ length: 6 }, (_, i) => {
                    const year = 2025 + i;
                    return { label: `${year}`, value: `${year}` };
                });
            } else {
                // Coaching Completion / Coaching Coverage
                const startYear = 2025;
                const startMonth = 6; // Juni
                const totalMonths = 72; // 3 tahun ke depan
                let y = startYear;
                let m = startMonth;
                const months = [];

                for (let i = 0; i < totalMonths; i++) {
                    if (m > 12) {
                        m = 1;
                        y++;
                    }
                    const label = `${monthNames[m - 1]} ${y}`;
                    const value = `${y}${String(m).padStart(2, '0')}`; // Format: YYYYMM
                    months.push({ label, value });
                    m++;
                }

                this.periodeOptions = months;
            }

            // Reset periode yang sebelumnya dipilih
            this.filters.periode_label = null;
        }
    },
};
</script>
